import React from "react";

import { IconProps } from "../../types/common";

import PriorityHighIcon from "./PriorityHighIcon";

// Same arrow as PriorityHighIcon, in the mid-priority colour — the two differ by fill only.
const PriorityMidIcon = ({ fillColor = "#F2A033", ...otherProps }: IconProps) => (
  <PriorityHighIcon fillColor={fillColor} {...otherProps} />
);

export default PriorityMidIcon;
